module.exports = __webpack_public_path__ + "static/assets/9cac426f599d3ac06ec5846bbda191cd.svg";